import { INSTANCE_URL, FILES_URL } from '../../Common/constant';
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest,
  uploadEncodedFile
} from '../../Common/network-call';

export const FETCH_APP_USERS_ALL_NOTES = 'FETCH_APP_USERS_ALL_NOTES';
export const OPEN_NOTE_DETAILS = 'OPEN_NOTE_DETAILS';
export const SHOW_BACK_NOTES_SCREEN = 'SHOW_BACK_NOTES_SCREEN';
export const FETCH_APP_USER_NOTES = 'FETCH_APP_USER_NOTES';

// actions with API Calls
export const fetchAppUserNotesOfNotes = (
  session,
  searchText = '',
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(note CONTAINS ${searchText})`
  );
  let orderby = 'updatedon%20DESC';
  let related =
    'appuser_by_attendeeid,exhibitors_by_exhibitorid,sponsor_by_sponsorid,speaker_by_speakerid';

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_notes?related=${related}&include_count=true&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_APP_USERS_ALL_NOTES,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchAppUserNotes = (session, key, id, callback) => {
  // console.log('session: ', session);
  let filter = '';

  if (key == 'exhibitor') {
    filter = encodeURI(
      `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(exhibitorid=${id})`
    );
  } else if (key == 'sponsor') {
    filter = encodeURI(
      `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(sponsorid=${id})`
    );
  } else if (key == 'speaker') {
    filter = encodeURI(
      `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(speakerid=${id})`
    );
  } else if (key == 'attendee') {
    filter = encodeURI(
      `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(attendeeid=${id})`
    );
  }

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_notes?include_count=true&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_APP_USER_NOTES,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource, count: data.meta.count }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const clearAppUserNotes = () => {
  return dispatch => {
    dispatch({
      type: FETCH_APP_USER_NOTES,
      payload: {}
    });
  };
};

export const clearAppUserAllNotes = () => {
  return dispatch => {
    dispatch({
      type: FETCH_APP_USERS_ALL_NOTES,
      payload: {}
    });
  };
};

export const addNote = (session, resource, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_notes`;
  let body = {
    resource: resource
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response.resource[0] });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const updateNote = (session, id, resource, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_notes/${id}`;
  return dispatch => {
    patchRequest(
      url,
      resource,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const uploadMedia = (session, uploadFiles, callback) => {
  if (uploadFiles?.file) {
    let filecontent = uploadFiles.file.split(';base64,')[1]; // for all type of file
    let filename = `eventify/${session.eventid}/images/appuser/notes/${uploadFiles.name}`;

    let mediaJson = {
      resource: [
        {
          name: filename,
          type: 'file',
          is_base64: true,
          content: filecontent
        }
      ]
    };
    return dispatch => {
      uploadEncodedFile(
        `${FILES_URL}?check_exist=false`,
        session,
        mediaJson,
        dispatch,
        response => {
          callback({ success: 1, data: response });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  } else {
    return dispatch => {
      callback({ success: 1 });
    };
  }
};

export const deleteNote = (session, noteid, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(id=${noteid})`
  );
  const url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_notes?filter=(${filter})`;
  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1, response });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

// actions w/o NCalls
export const openNoteDetails = noteData => {
  return dispatch => {
    dispatch({ type: OPEN_NOTE_DETAILS, payload: noteData });
  };
};

export const showBackNotesScreen = toggle => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_NOTES_SCREEN, payload: toggle });
  };
};
